// JSA Employee Signatures Info
import { v4 as uuidv4 } from "uuid";

export class JsaEmployeeSignaturesInfo {
  constructor(data = {}) {
    this.rowId = data.id || uuidv4();
    this.employeeId = data.employee_id || "";
    this.employeeName =
      data.employee_id && data.employee_name
        ? `${data.employee_id} - ${data.employee_name}`
        : data.employee_name || "";
    // Base64 encoded signature
    this.employeeSig = data.employee_sig
      ? "data:image/png;base64," + data.employee_sig
      : "";
  }

  // Updating the employee information, when someone is selected from the employee dropdown list
  updateSelectedEmployee(employee) {
    if (!employee) {
      this.employeeId = "";
      this.employeeName = "";
    } else {
      this.employeeId = employee.employeeId;
      this.employeeName = employee.employeeName;
    }
  }

  // updating the signature
  updateSignature(signature) {
    if (!signature) {
      this.employeeSig = "";
    } else {
      this.employeeSig = signature;
    }
  }

  // To json for sending to the database
  toJson() {
    // Removing the data:image/png;base64, from the signature
    const employeeSig = this.employeeSig
      .replace("data:image/png;base64,", "")
      .trim();
    return {
      id: this.rowId,
      employee_id: this.employeeId,
      employee_sig: employeeSig,
    };
  }

  // Helper for single and multi-field patches to be sent via websocket
  toPatch(fields, jsaId, action = "update") {
    const patch = {
      patch_type: "jsa_signatures",
      jsa_id: jsaId,
      id: this.rowId,
      action,
    };

    // Add employee_id if provided
    if (fields.employeeId !== undefined) {
      patch.employee_id = fields.employeeId;
    }

    // Add employee_sig if provided (remove base64 prefix)
    if (fields.employeeSig !== undefined) {
      const cleanSig = (fields.employeeSig || "")
        .replace("data:image/png;base64,", "")
        .trim();
      patch.employee_sig = cleanSig;
    }

    return patch;
  }
}
